import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Per-user Recall meeting bot counts, sorted by `created` (highest first).
 * `orgId` lists every member of that org (zero-bot members included, with
 * name/email); without it, every user who ever had a bot (no name/email).
 * `month` is `yyyy-MM` and filters by bot creation month; omit for all time.
 * Counts are cached for an hour server-side — `forceRefresh` recomputes now
 * and can take a few seconds for a large org or for all users.
 */
const getRecallBotUsage = (
  { orgId, month, forceRefresh },
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get('/ads/recall-bot-usage', {
            params: {
              'request-id': reqId,
              ...(orgId ? { orgId } : {}),
              ...(month ? { month } : {}),
              forceRefresh: Boolean(forceRefresh),
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data || []);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to fetch Recall bot usage');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback('Failed to fetch Recall bot usage');
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to fetch Recall bot usage');
    }
  };
};

export default getRecallBotUsage;
